import { SPACE_INVADERS_TEXTURE_KEYS } from '.'

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/animations/space-invaders/`

  if (!scene.textures.getTextureKeys().includes(SPACE_INVADERS_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      SPACE_INVADERS_TEXTURE_KEYS.ATLAS,
      `${prefix}atlas/animation-space-invaders-images.json`,
      `${prefix}atlas/`,
    )
  }
}
